// Verbindung.jsx — Hinweis auf der Leinwand, wenn der Server nicht antwortet
// (18.10.2026). Ohne ihn stünde am Beamer still der letzte Stand, und niemand
// wüsste, dass das Panel längst weiter ist.
import React from 'react';
import '../../styles/leinwand.css';

export default function Verbindung({ fehler }) {
  if (!fehler) return null;
  return <div className="lw-verbindung" role="status">Keine Daten vom Server: {fehler}</div>;
}
